import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import SiteHeader from "@/components/SiteHeader";
import Seo from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";
import { PRIVACY_PT, PRIVACY_EN } from "./privacidadeContent";

export default function PrivacidadePage() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const pt = language !== "en";
  const SECTIONS = pt ? PRIVACY_PT : PRIVACY_EN;

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Poppins', 'Montserrat', sans-serif" }}>
      <SiteHeader active="" onBuyClick={() => navigate("/#passport")} />
      <Seo
        title={pt ? "Política de Privacidade" : "Privacy Policy"}
        description={pt ? "Política de Privacidade (RGPD) da plataforma PASS Algarve: dados recolhidos, finalidades e direitos do titular." : "PASS Algarve Privacy Policy (GDPR): data collected, purposes and data subject rights."}
      />

      {/* Hero */}
      <section className="bg-[#071A35] pt-28 pb-12" data-testid="privacy-hero">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#D4A85D] text-xs font-bold uppercase tracking-[0.25em] mb-3">PASS ALGARVE</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
            {pt ? "Política de Privacidade" : "Privacy Policy"}
          </h1>
          <p className="text-white/60 text-sm">{pt ? "Última atualização: 1 de setembro de 2026" : "Last updated: September 1, 2026"}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 lg:py-16 bg-white flex-1" data-testid="privacy-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-[#071A35]/80 text-sm leading-relaxed space-y-4 mb-10">
            <p>
              {pt
                ? "A presente Política de Privacidade descreve como o PASS Algarve recolhe, utiliza, partilha e protege os dados pessoais dos utilizadores da plataforma, em conformidade com o Regulamento Geral sobre a Proteção de Dados (Regulamento (UE) 2016/679 — RGPD) e demais legislação aplicável."
                : "This Privacy Policy describes how PASS Algarve collects, uses, shares and protects the personal data of platform users, in accordance with the General Data Protection Regulation (Regulation (EU) 2016/679 — GDPR) and other applicable legislation."}
            </p>
          </div>

          <div className="space-y-10">
            {SECTIONS.map((s, i) => (
              <div key={i} data-testid={`privacy-section-${i + 1}`}>
                <h2 className="text-[#071A35] font-bold text-lg mb-3 pb-2 border-b border-[#D4A85D]/30">{s.title}</h2>
                <div className="text-[#071A35]/80 text-sm leading-relaxed space-y-3">
                  {s.paras.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                  {s.list && (
                    <ul className="list-none space-y-1.5 pl-1">
                      {s.list.map((li, k) => (
                        <li key={k} className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 rounded-full bg-[#D4A85D] mt-1.5 flex-shrink-0" />
                          {li}
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.parasAfter && s.parasAfter.map((p, j) => <p key={`a${j}`}>{p}</p>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
